// extracted by mini-css-extract-plugin
var _1 = "ratedisclosures_effectivedate__bkv6t";
var _2 = "ratedisclosures_wrapper__5bt1e";
export { _1 as "effectiveDate", _2 as "wrapper" }
